<template>
  <div class="page home">
    <div class="page-container">
      <slider data-aos="fadeDown"></slider>
      <posts-listing/>
    </div>
  </div>
</template>
<script>
import PostsListing from '@/components/Posts/PostsListing'
import Slider from '@/components/Slider/Slider'

export default {
  components: { PostsListing, Slider },
  mounted () {
    document.title = 'Komachi - Restaurant Japonais'
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue